import React, { Component } from 'react';
import { connect } from 'react-redux';
import { currencyFormat } from '../../../../utils/helpers/currency';
import { numberFormat, ctrFormat, averagePercentFormat } from '../../../../utils/helpers/number_formatter';
import { StatBar } from '../../../../components/common';

class StatCards extends Component {
  render() {
    const { stats } = this.props;
    const valueStyles = { fontSize: '14px' };
    const boxStyles = { height: '100px' };

    return (
      <div>
        <StatBar
          label="Total Spend"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={currencyFormat(stats?.gross_total_spend || 0.0)}
        />
        <StatBar
          label="Click Spend"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={currencyFormat(stats?.gross_click_spend || 0.0)}
        />
        <StatBar
          label="Video Spend"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={currencyFormat(stats?.gross_video_spend || 0.0)}
        />
        <StatBar
          label="Impressions"
          column="col-lg-2 col-md-12 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_impressions || 0)}
        />
        <StatBar
          label="Clicks"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_clicks || 0)}
        />
        <StatBar
          label="Conversions"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_conversions || 0)}
        />
        <StatBar
          label="Total Clicks"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_total_clicks || 0.0)}
        />
        <StatBar
          label="Fraud Clicks"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_fraud_clicks || 0.0)}
        />
        <StatBar
          label="Expired Clicks"
          column="col-md-2"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_expired_clicks || 0.0)}
        />
        <StatBar
          label="Foreign Clicks"
          column="col-lg-2 col-md-12 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_foreign_clicks || 0)}
        />
        <StatBar
          label="Latent Clicks"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_latent_clicks || 0)}
        />
        <StatBar
          label="Excluded Clicks"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_excluded_clicks || 0)}
        />
        <StatBar
          label="Duplicate Clicks"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_duplicate_clicks || 0)}
        />
        <StatBar
          label="Ovr Budget Clicks"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_over_budget_clicks || 0)}
        />
        <StatBar
          label="Video Views"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={numberFormat(stats?.gross_video_views || 0)}
        />
        <StatBar
          label="CTR"
          column="col-lg-2 col-md-12 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={ctrFormat(stats?.gross_ctr || 0.0)}
        />
        <StatBar
          label="ACPC"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={averagePercentFormat(stats?.median_acpc || 0)}
        />
        <StatBar
          label="ACPA"
          column="col-lg-2 col-md-6 col-sm-6"
          valueStyles={valueStyles}
          boxStyles={boxStyles}
          value={averagePercentFormat(stats?.median_acpa || 0)}
        />
      </div>
    );
  }
}

const mapStateToProps = (_state, props) => {
  const stats = props.stats;
  return { stats };
};
export default connect(mapStateToProps)(StatCards);
